
import { Component, Vue } from "vue-property-decorator"
import { DimssaButton } from "@/components/dimssa-button.vue"
import store from "@/store"

@Component({
  components: {
    DimssaButton,
  },
})
export default class Home extends Vue {
  get userEmail(): string {
    const state = this.$store?.state as any
    return state?.user?.email || state?.user?.user?.email || ""
  }

  get hasDeveloperAccess(): boolean {
    return ["dolan@gigalot.co.za", "paul@gigalot.co.za"].includes(this.userEmail)
  }

  get hasSupportAccess(): boolean {
    return this.hasDeveloperAccess || this.userEmail === "william@gigalot.co.za"
  }

  get hasAdminAccess(): boolean {
    return this.userEmail === "dawie@gigalot.co.za"
  }

  async resubscribe() {
    /*
      We don't use this anymore, PubSub topics must still be created, but EventArc is then used for trigger/subscription management.
    */
    // let options: RequestInit = {
    //   method: "GET",
    //   headers: { Accept: "application/json" },
    //   mode: "no-cors",
    // }
    // let response = await fetch(`${store.getters["backendUrl"]()}/resubscribe`, options)
    // console.log(response)
  }

  async test() {
    console.log("test()")

    let gql = `mutation testIam($x: String!) {
			testIam(x: $x)
		}`

    let json = await store.dispatch("graphQl", {
      gql,
      //variables: { deviceId: mqttDeviceId(what, gcp, guid, num), registryId: mqttDeviceRegistryId(what) }
      variables: { x: "123" },
    })

    console.log(JSON.stringify(json))
    //return json;
  }
}
